<template>
  <v-modal v-if="showModal" @close="closeModal()">
    <template v-slot:title>
      <h2 class="card-title">
        <template v-if="selectedItem.name">{{ selectedItem.name }}</template>
        <template v-if="!selectedItem.name">Zonder titel</template>
      </h2>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-12 col-lg-8">
          <template v-if="selectedItem.collection_images.length">
            <!-- <img class="card-img-top" :src="selectedItem.collection_images[0].thumb.url" /> -->
            <img
              data-sizes="auto"
              :data-src="selectedItem.collection_images[0].thumb.url"
              :data-srcset="selectedItem.collection_images[0].srcset"
              class="card-img-top lazyload"
            />
          </template>
          <template v-if="!selectedItem.collection_images.length">geen foto</template>
        </div>

        <div class="col-12 col-lg-4">
          <div class="card-body">
            <h5 v-if="selectedItem.name" class="card-title">{{ selectedItem.name }}</h5>

            <p v-if="selectedItem.short_description" class="card-text">
              {{ selectedItem.short_description }}
            </p>

            <p class="card-text">
              <a :href="selectedItem.museum.url">{{ selectedItem.museum.title }}</a>
            </p>

            <p class="card-text" v-if="selectedItem.materials.length">
              <small class="text-muted">
                materialen:
                <span v-for="(material, idx) in selectedItem.materials" :key="`item-${idx}`">
                  {{ material.title }}
                </span>
              </small>
            </p>

            <p class="card-text" v-if="selectedItem.object_id">
              <small class="text-muted">
                object ID:
                <span>{{ selectedItem.object_id }}</span>
              </small>
            </p>

            <p class="card-text" v-if="selectedItem.collection_name">
              <small class="text-muted">
                collectie:
                <span>{{ selectedItem.collection_name.title }}</span>
              </small>
            </p>

            <p class="card-text" v-if="selectedItem.start_year">
              <small class="text-muted">
                jaren:
                <span>{{ selectedItem.start_year }}</span>
                <span v-if="selectedItem.end_year">- {{ selectedItem.end_year }}</span>
              </small>
            </p>

            <p class="card-text" v-if="selectedItem.techniques.length">
              <small class="text-muted">
                technieken:
                <span v-for="(technique, idx) in selectedItem.techniques" :key="`item-${idx}`">
                  {{ technique.title }}
                </span>
              </small>
            </p>

            <p class="card-text" v-if="selectedItem.collection_maker_relationship.length">
              <small class="text-muted">
                Maker, rol &amp; plaats:
                <div
                  v-for="(maker_role, idx) in selectedItem.collection_maker_relationship"
                  :key="`item-${idx}`"
                >
                  <span v-if="maker_role.maker.maker">{{ maker_role.maker.maker.title }}</span>
                  <span v-if="maker_role.maker.role">- {{ maker_role.maker.role.title }}</span>
                  <span v-if="maker_role.maker.place">- {{ maker_role.maker.place.title }}</span>
                </div>
              </small>
            </p>

            <p class="card-text" v-if="selectedItem.eras.length">
              <small class="text-muted">
                tijdperk:
                <span v-for="(era, idx) in selectedItem.eras" :key="`item-${idx}`">
                  {{ era.title }}
                </span>
              </small>
            </p>

            <p class="card-text" v-if="selectedItem.license">
              <small class="text-muted">
                licentie:
                <span>{{ selectedItem.license.title }}</span>
              </small>
            </p>
          </div>
        </div>
      </div>
    </template>
  </v-modal>
</template>

<script>
import VModal from './VModal.vue';
import 'lazysizes'; // pikt juiste breedte voor img srcset
import 'lazysizes/plugins/attrchange/ls.attrchange'; // nodig na filtering

export default {
  name: 'ItemDetail',
  components: {
    VModal,
  },
  props: {
    value: null,
    showModal: null,
  },
  computed: {
    selectedItem() {
      return this.value;
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>
